// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3GxX0","list":"PatternAutocomplete_list__3VCE6"};